import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "../styles.css";

const Navbar = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [userRole, setUserRole] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const adminLoggedIn = localStorage.getItem("adminLoggedIn");
    const siswaLoggedIn = localStorage.getItem("siswaLoggedIn");
    if (adminLoggedIn) setUserRole("admin");
    else if (siswaLoggedIn) setUserRole("siswa");
    else setUserRole(null);
  }, [location]);

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const handleLogout = () => {
    localStorage.removeItem("adminLoggedIn");
    localStorage.removeItem("siswaLoggedIn");
    setUserRole(null);
    navigate("/");
  };

  const menuItems = [
    {
      label: "Profil Sekolah",
      subMenu: [
        { label: "Sejarah", path: "/profil/sejarah" },
        { label: "Visi Misi", path: "/profil/visi-misi" },
        { label: "Informasi Guru & Staf", path: "/informasi-guru" },
        { label: "Fasilitas Sekolah", path: "/profil/fasilitas" },
      ],
    },
    {
      label: "Informasi",
      subMenu: [
        { label: "Pengumuman & Agenda", path: "/informasi" },
        { label: "Berita", path: "/informasi/berita" },
        { label: "Galeri", path: "/informasi/galeri" },
        { label: "Ekstrakurikuler", path: "/informasi/ekstrakurikuler" },
      ],
    },
    {
      label: "PPDB",
      subMenu: [
        { label: "Informasi Pendaftaran", path: "/ppdb/informasi" },
        { label: "Status Pendaftaran", path: "/login" },
      ],
    },
  ];

  const getLoginButton = () => {
    if (userRole === "admin")
      return { text: "Kembali ke Beranda Admin", path: "/admin" };
    if (userRole === "siswa")
      return { text: "Kembali ke Beranda Siswa", path: "/siswa" };
    return { text: "Login", path: "/login" };
  };

  const { text, path } = getLoginButton();

  return (
    <nav className="navbar navbar-expand-lg shadow-sm sticky-top custom-navbar">
      <div className="container py-2">
        <Link
          className="navbar-brand d-flex align-items-center fw-bold text-white"
          to="/"
        >
          <img
            src="/assets/logo-smp.png"
            alt="Logo Sekolah"
            className="me-2 navbar-logo"
          />
          <span className="brand-text">
            SMP Muhammadiyah <br />
            <small className="fw-normal">2 Bolang Dayeuhluhur</small>
          </span>
        </Link>

        <button
          className="navbar-toggler text-white border-0"
          type="button"
          onClick={handleNavCollapse}
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className={`collapse navbar-collapse ${!isNavCollapsed ? "show" : ""}`}>
          <ul className="navbar-nav ms-auto align-items-lg-center">
            <li className="nav-item mx-2">
              <Link
                to="/"
                className="nav-link fw-semibold nav-link-elegant"
                onClick={() => setIsNavCollapsed(true)}
              >
                Home
              </Link>
            </li>

            {menuItems.map((menu, i) => (
              <li className="nav-item dropdown mx-2" key={i}>
                <span
                  className="nav-link dropdown-toggle fw-semibold nav-link-elegant"
                  role="button"
                  data-bs-toggle="dropdown"
                >
                  {menu.label}
                </span>
                <ul className="dropdown-menu fade-up">
                  {menu.subMenu.map((sub, j) => (
                    <li key={j}>
                      <Link
                        className="dropdown-item"
                        to={sub.path}
                        onClick={() => setIsNavCollapsed(true)}
                      >
                        {sub.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </li>
            ))}

            {/* Tombol utama login/beranda */}
            <li className="nav-item ms-lg-3">
              <Link
                to={path}
                className="btn btn-light fw-semibold px-3 py-1 rounded-pill me-2"
                onClick={() => setIsNavCollapsed(true)}
              >
                {text}
              </Link>
              {/* Logout muncul kalau login */}
              {userRole && (
                <button
                  onClick={handleLogout}
                  className="btn btn-outline-light fw-semibold px-3 py-1 rounded-pill"
                >
                  Logout
                </button>
              )}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
